export default {
  namespaced: true,
  state: {
    id: 0,
    name: '',
    workingSpace: '',
    nickName: '',
    createTime: '',
    workingSpaceShow: '',
    placeId: '',
    samplingSite: ''
  },
  mutations: {
    updateId (state, id) {
      state.id = id
    },
    updateName (state, name) {
      state.name = name
    },
    setWorkingSpace (state, val) {
      state.workingSpace = val
    },
    setNickName (state, val) {
      state.nickName = val
    },
    setWorkingSpaceShow  (state, val) {
      state.workingSpaceShow = val
    },
    setCreateTime (state, val) {
      state.createTime = val
    },
    setPlaceId (state, val) {
      state.placeId = val
    },
    setSamplingSite (state, val) {
      state.samplingSite = val
    }
  }
}
